export const ADD_ITEM = "ADD_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";

export const CREATE_TUTORIAL = "CREATE_TUTORIAL";
export const RETRIEVE_TUTORIALS = "RETRIEVE_TUTORIALS";
export const UPDATE_TUTORIAL = "UPDATE_TUTORIAL";
export const DELETE_TUTORIAL = "DELETE_TUTORIAL";
export const DELETE_ALL_TUTORIALS = "DELETE_ALL_TUTORIALS";

export const RETRIEVE_PRODUCTDETAILS = "RETRIEVE_PRODUCTDETAILS";


// Define action types
export const FETCH_POSTS_REQUEST = 'FETCH_POSTS_REQUEST';
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE';



export const GET_CRM_DATA = 'GET_CRM_DATA';
export const UPDATE_CRM_DATA = 'UPDATE_CRM_DATA';
export const GET_LOGGED_USER_DETAILS = 'GET_LOGGED_USER_DETAILS';

export const GET_ALL_OPPORTUNITY_BY_USER = 'GET_ALL_OPPORTUNITY_BY_USER';
export const GET_ALL_QUOTES_BY_OPPURTUNITY = 'GET_ALL_QUOTES_BY_OPPURTUNITY';


export const GET_QUOTES_TO_COMPARE = 'GET_QUOTES_TO_COMPARE';
export const ADD_QUOTES_TO_COMPARE = 'ADD_QUOTES_TO_COMPARE';
